import React from 'react';
import _ from 'lodash';
import { history } from 'userportal/history';
import notifications from 'shared/lib/notifications';
import { AUTH_LOGIN_NEEDED, AUTH_SIGNUP_SUCCEEDED, AUTH_LOGIN_SUCCEEDED, AUTH_LOGOUT, AUTH_FORCE_LOGOUT, AUTH_LOGIN_FAILED } from 'userportal/ducks/auth';
import { BULK_LOAD_FAILED, DIALS_LOAD_FAILED, BULK_LOADED } from 'userportal/ducks/global';
import { PROFILE_PARSE_SUCCESS, PROFILE_PARSE_FAILED, selectors as profileSelectors } from 'userportal/ducks/profile';
import { userportal as routes } from 'shared/routes';
import i18n from 'shared/i18n/init';

i18n.on('initialized', () => {
  i18n.changeLanguage(i18n.language);
});

const failedActionRegexp = /_FAILED$/;
const ignored = [AUTH_LOGIN_FAILED, BULK_LOAD_FAILED, DIALS_LOAD_FAILED];

export default function alertMiddleware({ dispatch, getState }) {
  return next => (action) => {
    if (typeof action === 'function') {
      return action(dispatch, getState);
    }

    const nextResult = next(action);
    const state = getState();
    const hasInsufficientProfile = profileSelectors.hasInsufficientProfile(state);

    setTimeout(() => {
      switch (action.type) {
        case BULK_LOADED: {
          if (hasInsufficientProfile && !(state.auth.oauthSignup || state.auth.signup)) {
            notifications.addWarning(i18n.t('userportal:notification.insufficientProfile'), {
              autoClose: 10000,
              closeOnClick: true,
              onClick() {
                history.push(routes.user.profile.view);
              }
            });
            // history.push(routes.user.profile.view);
          }
        } break;

        case AUTH_FORCE_LOGOUT:
          notifications.addError(i18n.t('userportal:notification.forceLogout'));
          break;

        case AUTH_LOGIN_NEEDED:
          notifications.addWarning(i18n.t('userportal:notification.loginNeeded'));
          break;

        case AUTH_SIGNUP_SUCCEEDED:
          if (action.result.oauth && !action.result.oauthSignup) {
            notifications.addSuccess(i18n.t('userportal:notification.welcomeBack', { name: i18n.t('common:name') }));
          } else {
            notifications.addInfo(
              i18n.t('userportal:notification.signupWelcome', { name: i18n.t('common:name') }),
              {
                autoClose: 10000,
                closeOnClick: true,
                onClick() {
                  history.push(routes.user.profile.view);
                }
              }
            );
          }
          break;

        case AUTH_LOGIN_SUCCEEDED:
          if (action.result.oauthSignup) {
            notifications.addInfo(
              i18n.t('userportal:notification.signupWelcome', { name: i18n.t('common:name') }),
              {
                autoClose: 10000,
                closeOnClick: true,
                onClick() {
                  history.push(routes.user.profile.view);
                }
              }
            );
          } else {
            notifications.addSuccess(i18n.t('userportal:notification.welcomeBack', { name: i18n.t('common:name') }));
          }
          break;

        case AUTH_LOGOUT:
          notifications.addInfo(i18n.t('userportal:notification.logout'));
          break;

        case PROFILE_PARSE_SUCCESS:
          notifications.addSuccess(
            `${i18n.t(`userportal:notification.profileParseSuccess.${action.payload.request.type}`)} ${i18n.t('userportal:notification.profileParseSuccess.common')}`,
            {
              autoClose: 10000,
              closeOnClick: true,
              onClick() {
                history.push(routes.contactForm);
              }
            }
          );
          break;

        case PROFILE_PARSE_FAILED:
          if (action.payload.request.error) {
            const commonSuffix = action.payload.request.error !== 'common:error.linkedInUrlNotFound';
            notifications.addError(
              `${i18n.t(action.payload.request.error)} ${commonSuffix ? i18n.t('common:error.commonErrorSuffix') : ''}`,
              {
                autoClose: 10000,
                closeOnClick: true,
                onClick: commonSuffix ? () => history.push(routes.contactForm) : undefined,
              }
            );
          } else {
            notifications.addError(
              `${i18n.t(`common:error.failedToParseEntity.${action.payload.request.type}`)} ${i18n.t('common:error.commonErrorSuffix')}`,
              {
                autoClose: 10000,
                closeOnClick: true,
                onClick() {
                  history.push(routes.contactForm);
                }
              }
            );
          }
          break;

        default:
          if (failedActionRegexp.test(action.type) && !ignored.includes(action.type)) {
            let additionalErrors = null;
            if (action.response && Array.isArray(action.response.errors)) {
              const errors = action.response.errors.map((err) => {
                if (_.isString(err) && i18n.exists(err)) {
                  return i18n.t(err);
                }

                return null;
              }).filter(Boolean);

              if (errors.length > 0) {
                additionalErrors = (
                  <ul>
                    {errors.map(err => <li key={err}>{err}</li>)}
                  </ul>
                );
              }
            }

            if (_.isString(action.error) && i18n.exists(action.error)) {
              notifications.addError(
                <>
                  <p>{i18n.t(action.error)}</p>
                  {additionalErrors}
                </>
              );
            } else {
              notifications.addError(
                <>
                  <p>{i18n.t('common:notification.requestFailed')}</p>
                  {additionalErrors}
                </>
              );
            }
          }
          break;
      }
    });

    return nextResult;
  };
}
